<template>
  <a class="skip-link" href="#contenu">Aller au contenu</a>
  <site-header/>
  <main id="contenu" class="app-content" tabindex="-1">
    <router-view :key="$route.path"/>
  </main>
  <footer-component/>
</template>

<script>
  import SiteHeader from "@/components/SiteHeader.vue";
  import FooterComponent from "@/components/FooterComponent.vue";

  export default {
    name: 'App',
    components: {
      SiteHeader,
      FooterComponent,
    },
  }
</script>

<style lang="stylus">
  @import '~/src/common/style/common.styl';

  .app-content
    min-height 60vh
    outline none
</style>
